import React, { useEffect, useState } from 'react';
import axios from 'axios';
import RippleButton from '../../../../components/Buttons/RippleButton';
import { BiCalendar } from 'react-icons/bi';
import { IoClose, IoCloseCircle } from 'react-icons/io5';
import { motion } from 'framer-motion';
import JobCard from '../../../components/Cards/JobCard'; // Composant pour une carte d'application
import JobCardSkeleton from '../../../components/Skeletons/JobCardSkeleton';
import { API_END_POINT, JOB_API_END_POINT } from '../../../../utils/constant';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Enrollment = () => {
  const [favoriteOffers, setFavoriteOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null)
  const {id}= useParams()
  const {user} = useSelector(store=>store.user)

  useEffect(() => {
    // Récupérer les données via l'API avec axios
    axios.get(JOB_API_END_POINT+'/favorite/'+user?.id+'/all')
      .then(response => {
        console.log(response.data)
        setFavoriteOffers(response.data); // Charger les données de l'API
        setLoading(false); // Arrêter l'état de chargement
      })
      .catch(error => {
        setError('Erreur lors du chargement des favoriteOffers'+ error);
        setLoading(false); // Arrêter l'état de chargement même en cas d'erreur
      });
  }, []);

  return (
    <div className='min-h-full w-full pr-6 xl:pr-40 pl-6 text-primary-black py-10'>
      <div className="bg-white py-4 text-sm">
        <div className="overflow-x-auto gap-4">
          {loading ? (
            // Afficher des squelettes de cartes pendant le chargement
            Array.from({ length: 6 }).map((_, index) => (
              <JobCardSkeleton key={index} />
            ))
          ) : error ? (
            // Afficher un message d'erreur si l'API échoue
            <div className="text-center py-6 text-red-500">
              {error}
            </div>
          ) : 
          favoriteOffers?.length ? (
            favoriteOffers?.map((application, index) => (
              <motion.div
                key={application.id}
                initial={{ opacity: 0, y: 100 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -100 }}
                transition={{ duration: 0.5 + index / 10 }}
              >
                <JobCard item={application?.offer} />
              </motion.div>
            ))
          ) : (
            // Afficher un texte si aucune application n'est trouvée
            <div className="text-center py-6 text-gray-500">
              Aucune application trouvée.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Enrollment;
